import Vue from 'vue'
import Cleave from 'vue-cleave-component/src/component'
import 'cleave.js/dist/addons/cleave-phone.se.js'

Vue.component('Cleave', Cleave)
